import React, {ReactNode} from "react";
import {Box, Drawer, useMediaQuery, useTheme} from "@mui/material";
import {useDrawer} from "./DrawerProvider";

export const drawerWidth = 240;

export function CustomDrawer(props: {
  children?: ReactNode;
}) {
  const theme = useTheme();
  const smallScreens = useMediaQuery(theme.breakpoints.down('md'));
  const {drawerOpen, toggleDrawer} = useDrawer();

  const sx= {
    height: '101%',
    '& .MuiDrawer-paper': {
      top: 'unset',
      width: drawerWidth,
      backgroundColor: theme.palette.background.light,
      paddingTop: theme.spacing(4),
    }
  }

  if (smallScreens) {
    return (
      <Drawer
        variant="temporary"
        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
        open={drawerOpen}
        onClose={toggleDrawer}
        sx={sx}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
      >
        {props.children}
      </Drawer>
    )
  }

  return (
    <Box sx={{
      [theme.breakpoints.up('md')]: {
        width: drawerWidth,
      }
    }} aria-label="menu">
      <Drawer
        sx={sx}
        variant="permanent"
        open
      >
        {props.children}
      </Drawer>
    </Box>
  );
}
